<template>
    <div class="investors-header">
        <app-header-mini v-if="this.$route.params.page === 'management'" :img="'/static/img/investors/management/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'financial-statements'" :img="'/static/img/investors/fs/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'general-meetings'" :img="'/static/img/investors/gm/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'calendar'" :img="'/static/img/investors/calendar/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'shares'" :img="'/static/img/investors/shares/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'presentations'" :img="'/static/img/investors/presentations/header.jpg'" :texts="texts"></app-header-mini>
    </div>
</template>

<script>
import HeaderMini from "../shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  },
  data() {
    return {
      texts: [
        "Investors"
      ]
    };
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/investors/Header.vue